module.exports = __webpack_public_path__ + "img/grid-listing-active.9ae39f5c.svg";